import { Action, ICON_ARROW_UP } from '@doveit/bricks';
import React from 'react';
import { getNextColdLeadContact, getNextLeadContact } from '../../../providers/api/call-center/callCenterLeadProvider';
import { CallContextType, ProcessableContact } from '../../../providers/api/dtos';
import { useMatchMutate } from '../../../utils/swr/swr';
import {
  FEEDBACKS_COUNT_RID,
  NEXT_CALLCENTER_COLD_LEAD_CONTACTS_COUNT_RID,
  NEXT_CALLCENTER_CONTACTS_COUNT_RID,
} from '../../hooks/use-contact-to-process-count/useContactToProcessCount';
import { getNextFeedbackContactId } from '../../../providers/api/call-center/callCenterFeedbackProvider';

export interface NextContactToProcessActionProps {
  type: CallContextType,
  disabled?: boolean,
  onSuccess?: (processableContact?: ProcessableContact) => void,
  onError?: (err: Error) => void,
}

const NextContactToProcessAction: React.FC<NextContactToProcessActionProps> = ({
  type,
  disabled,
  onSuccess,
  onError,
}) => {
  const [loading, setIsLoading] = React.useState(false);
  const mutateCallCenterContactsCount = useMatchMutate();

  const onClick = React.useCallback(async () => {
    setIsLoading(true);

    try {
      let processableContact: ProcessableContact | undefined;
      let rid: string | undefined;

      switch (type) {
        case CallContextType.LEAD: {
          rid = NEXT_CALLCENTER_CONTACTS_COUNT_RID;
          processableContact = await getNextLeadContact(); break;
        }
        case CallContextType.COLD_LEAD: {
          rid = NEXT_CALLCENTER_COLD_LEAD_CONTACTS_COUNT_RID;
          processableContact = await getNextColdLeadContact(); break;
        }
        case CallContextType.SURVEY: {
          rid = FEEDBACKS_COUNT_RID;
          processableContact = await getNextFeedbackContactId(); break;
        }
        default: {
          rid = '';
          processableContact = undefined;
        }
      }
      setIsLoading(false);
      mutateCallCenterContactsCount(rid);

      onSuccess?.(processableContact);
    } catch (err) {
      setIsLoading(false);

      onError?.(err as Error);
    }
  }, [type, mutateCallCenterContactsCount, onSuccess, onError]);

  return (
    <Action
      label="Prossimo contatto"
      aria-label="Prossimo contatto da processare"
      iconRight={{
        path: ICON_ARROW_UP,
        direction: 'right',
      }}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default NextContactToProcessAction;
